"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketTypes = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var TicketTypes = function TicketTypes(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Ticket Types',
    viewBox: "0 0 320 250",
    __UIScope: "TicketTypes"
  }), react_1.default.createElement("rect", {
    width: "320",
    height: "224",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.75",
    rx: "12"
  }), react_1.default.createElement("g", {
    filter: "url(#TicketTypes__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "240",
    height: "64",
    x: "16",
    y: "20",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "31",
    y: "36",
    fill: ui_symbols_1.COLOR.RED[100],
    rx: "16"
  }), react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "31",
    y: "36",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "16"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.RED[500],
    fillRule: "evenodd",
    d: "M54.567 48.3l.525.523a.83.83 0 01.241.583v.98a.83.83 0 01-.241.583l-9.109 9.123a.834.834 0 01-.583.241h-.983a.834.834 0 01-.584-.24l-.525-.525a.83.83 0 01-.216-.931c.108-.264.161-.547.158-.832 0-1.148-.933-2.079-2.083-2.079a2.148 2.148 0 00-.834.158.834.834 0 01-.9-.216l-.525-.524a.83.83 0 01-.241-.582v-.982a.83.83 0 01.241-.582l9.109-9.09a.835.835 0 01.583-.24h.983a.835.835 0 01.584.207l.525.524a.83.83 0 01.216.931 2.134 2.134 0 00-.158.832c0 1.148.933 2.08 2.083 2.08.286.003.57-.051.834-.159a.834.834 0 01.9.217zm-9.234 3.684c0 .918.747 1.663 1.667 1.663s1.667-.745 1.667-1.663c0-.919-.747-1.664-1.667-1.664s-1.667.745-1.667 1.664z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "74",
    y: "37",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "154",
    y: "37",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY[400],
    d: "M218 46.733c0 .83-.262 1.504-.786 2.02-.514.515-1.195.82-2.041.916V51h-1.225v-1.346c-.937-.114-1.658-.448-2.162-1.002-.504-.563-.766-1.279-.786-2.148h1.708c.021.573.197 1.012.53 1.318.332.305.796.458 1.391.458.534 0 .942-.13 1.224-.387.292-.267.439-.615.439-1.045a1.12 1.12 0 00-.469-.93c-.313-.249-.847-.497-1.603-.745-.998-.325-1.738-.706-2.222-1.145-.474-.45-.711-1.065-.711-1.847 0-.764.237-1.403.711-1.919.474-.525 1.124-.835 1.95-.93V38h1.225v1.346c.766.114 1.366.415 1.799.902.443.487.68 1.14.711 1.961h-1.709c-.01-.467-.156-.83-.438-1.088-.283-.258-.65-.386-1.104-.386-.444 0-.796.119-1.058.358-.252.229-.378.548-.378.959 0 .41.141.725.423.945.282.21.801.448 1.557.716 1.099.362 1.875.773 2.329 1.23.463.45.695 1.046.695 1.79z"
  }), react_1.default.createElement("rect", {
    width: "18",
    height: "8",
    x: "222",
    y: "41",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "166",
    height: "8",
    x: "74",
    y: "59",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  })), react_1.default.createElement("g", {
    filter: "url(#TicketTypes__filter1_d)"
  }, react_1.default.createElement("rect", {
    width: "240",
    height: "64",
    x: "64",
    y: "96",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("g", {
    opacity: "0.5"
  }, react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "79",
    y: "112",
    fill: ui_symbols_1.COLOR.YELLOW[100],
    rx: "16"
  }), react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "79",
    y: "112",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "16"
  })), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.YELLOW[300],
    fillRule: "evenodd",
    d: "M102.567 124.299l.525.524c.154.155.24.364.241.583v.981a.83.83 0 01-.241.582l-9.109 9.123a.833.833 0 01-.583.241h-.983a.833.833 0 01-.584-.241l-.525-.524a.83.83 0 01-.216-.931c.108-.264.161-.547.158-.832a2.081 2.081 0 00-2.083-2.079 2.144 2.144 0 00-.834.158.835.835 0 01-.9-.216l-.525-.524a.831.831 0 01-.241-.582v-.982c0-.218.087-.427.241-.582l9.109-9.09a.837.837 0 01.583-.241h.983a.837.837 0 01.584.208l.525.524a.831.831 0 01.216.932 2.127 2.127 0 00-.158.831c0 1.148.933 2.079 2.083 2.079.286.004.569-.05.834-.158a.835.835 0 01.9.216zm-9.234 3.685c0 .918.746 1.663 1.667 1.663.92 0 1.667-.745 1.667-1.663 0-.919-.746-1.664-1.667-1.664-.92 0-1.667.745-1.667 1.664z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "122",
    y: "113",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "202",
    y: "113",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY[400],
    d: "M266 122.733c0 .831-.262 1.504-.786 2.019-.514.516-1.195.821-2.041.917V127h-1.225v-1.346c-.937-.114-1.658-.448-2.162-1.002-.504-.563-.766-1.279-.786-2.148h1.708c.021.573.197 1.012.53 1.318.332.305.796.458 1.391.458.534 0 .942-.129 1.224-.387.292-.267.439-.615.439-1.045a1.12 1.12 0 00-.469-.931c-.313-.248-.847-.496-1.603-.744-.998-.325-1.738-.706-2.222-1.145-.474-.449-.711-1.065-.711-1.847 0-.764.237-1.403.711-1.919.474-.525 1.124-.835 1.95-.931V114h1.225v1.346c.766.114 1.366.415 1.799.902.443.487.68 1.14.711 1.961h-1.709c-.01-.467-.156-.83-.438-1.088-.283-.258-.65-.386-1.104-.386-.444 0-.796.119-1.058.358-.252.229-.378.548-.378.959 0 .41.141.725.423.945.282.21.801.448 1.557.716 1.099.362 1.875.773 2.329 1.231.463.448.695 1.045.695 1.789z"
  }), react_1.default.createElement("rect", {
    width: "18",
    height: "8",
    x: "270",
    y: "117",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "166",
    height: "8",
    x: "122",
    y: "135",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  })), react_1.default.createElement("g", {
    filter: "url(#TicketTypes__filter2_d)"
  }, react_1.default.createElement("rect", {
    width: "240",
    height: "64",
    x: "16",
    y: "172",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "31",
    y: "188",
    fill: ui_symbols_1.COLOR.BLUE[100],
    rx: "16"
  }), react_1.default.createElement("rect", {
    width: "32",
    height: "32",
    x: "31",
    y: "188",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "16"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.THEME.PRIMARY,
    fillRule: "evenodd",
    d: "M54.567 200.299l.525.524c.154.155.24.364.241.583v.981a.831.831 0 01-.241.582l-9.109 9.123a.833.833 0 01-.583.241h-.983a.833.833 0 01-.584-.241l-.525-.524a.83.83 0 01-.216-.931c.108-.264.161-.547.158-.832a2.081 2.081 0 00-2.083-2.079 2.144 2.144 0 00-.834.158.835.835 0 01-.9-.216l-.525-.524a.831.831 0 01-.241-.582v-.982c0-.218.087-.427.241-.582l9.109-9.09a.837.837 0 01.583-.241h.983a.837.837 0 01.584.208l.525.524a.831.831 0 01.216.932 2.127 2.127 0 00-.158.831c0 1.148.933 2.079 2.083 2.079.286.004.57-.05.834-.158a.835.835 0 01.9.216zm-9.234 3.685c0 .918.747 1.663 1.667 1.663s1.667-.745 1.667-1.663c0-.919-.747-1.664-1.667-1.664s-1.667.745-1.667 1.664z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "74",
    y: "189",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "154",
    y: "189",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY[400],
    d: "M218 198.733c0 .831-.262 1.504-.786 2.019-.514.516-1.195.821-2.041.917V203h-1.225v-1.346c-.937-.114-1.658-.448-2.162-1.002-.504-.563-.766-1.279-.786-2.148h1.708c.021.573.197 1.012.53 1.318.332.305.796.458 1.391.458.534 0 .942-.129 1.224-.387.292-.267.439-.615.439-1.045a1.12 1.12 0 00-.469-.931c-.313-.248-.847-.496-1.603-.744-.998-.325-1.738-.706-2.222-1.145-.474-.449-.711-1.065-.711-1.847 0-.764.237-1.403.711-1.919.474-.525 1.124-.835 1.95-.931V190h1.225v1.346c.766.114 1.366.415 1.799.902.443.487.68 1.14.711 1.961h-1.709c-.01-.467-.156-.83-.438-1.088-.283-.258-.65-.386-1.104-.386-.444 0-.796.119-1.058.358-.252.229-.378.548-.378.959 0 .41.141.725.423.945.282.21.801.448 1.557.716 1.099.362 1.875.773 2.329 1.231.463.448.695 1.045.695 1.789z"
  }), react_1.default.createElement("rect", {
    width: "18",
    height: "8",
    x: "222",
    y: "193",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "166",
    height: "8",
    x: "74",
    y: "211",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "TicketTypes__filter0_d",
    width: "264",
    height: "88",
    x: "8",
    y: "8",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "TicketTypes__filter1_d",
    width: "264",
    height: "88",
    x: "56",
    y: "84",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "TicketTypes__filter2_d",
    width: "264",
    height: "88",
    x: "8",
    y: "160",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};

exports.TicketTypes = TicketTypes;